































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuporteAlterarSituacaoSolicitacaoStore, { SituacaoEtapa } from '@/components/Suporte/Store/SuporteAlterarSituacaoSolicitacaoStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteAlterarSituacaoSolicitacao extends Vue {
  loadupdateAlterarSituacaoSolicitacao: boolean = false

  get getSuporteAlterarSituacaoSolicitacaoStore() {
    return getModule(SuporteAlterarSituacaoSolicitacaoStore, this.$store)
  }

  get loadingUpdateAlterarSituacaoSolicitacao() {
    return this.loadupdateAlterarSituacaoSolicitacao
  }

  set loadingUpdateAlterarSituacaoSolicitacao(value: boolean) {
    this.loadupdateAlterarSituacaoSolicitacao = value
  }

  get showModalAlterarSituacaoSolicitacao() {
    return this.getSuporteAlterarSituacaoSolicitacaoStore.modal.alterarSituacaoSolicitacao
  }

  set showModalAlterarSituacaoSolicitacao(value: boolean) {
    this.getSuporteAlterarSituacaoSolicitacaoStore.setModal({ name: 'alterarSituacaoSolicitacao', value })
  }

  get statusSituacaoConfiguracao() {
    return this.getSuporteAlterarSituacaoSolicitacaoStore.statusSituacaoConfiguracao
  }

  set statusSituacaoConfiguracao(value: SituacaoEtapa) {
    this.getSuporteAlterarSituacaoSolicitacaoStore.setStatusSituacaoConfiguracao(value)
  }

  $refs!: {
    formAlterarSituacaoSolicitacao: any
  }

  formAlterarSituacaoSolicitacaoRules: any = {
    valid: true,
    statusSituacaoConfiguracao: [(v: any) => this.validateStatusSituacaoConfiguracao(v)],
  }

  validateStatusSituacaoConfiguracao(value: any) {
    if (!value.id || !value.etapa || !value.situacao) return 'Campo obrigatório.'
    return false
  }

  async updateSituacaoSolicitacao() {
    this.loadingUpdateAlterarSituacaoSolicitacao = true

    if (this.$refs.formAlterarSituacaoSolicitacao.validate()) {
      const response = await this.getSuporteAlterarSituacaoSolicitacaoStore.upsertStatusDaSolicitacao()

      if (!response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar a solicitação ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
        this.loadingUpdateAlterarSituacaoSolicitacao = false
        return
      }
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Solicitação alterada com sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })

      await this.getSuporteAlterarSituacaoSolicitacaoStore.getAllSolicitacoes(this.getSuporteAlterarSituacaoSolicitacaoStore.paginationSolicitacoes)
      this.showModalAlterarSituacaoSolicitacao = false
    }

    this.loadingUpdateAlterarSituacaoSolicitacao = false
  }

  @Watch('showModalAlterarSituacaoSolicitacao')
  onChangeShowModalAlterarSituacaoSolicitacao(value: boolean) {
    if (!value) {
      this.getSuporteAlterarSituacaoSolicitacaoStore.clearStatusSituacaoConfiguracao()
      this.getSuporteAlterarSituacaoSolicitacaoStore.setSolicitacaoId('')
      this.$refs.formAlterarSituacaoSolicitacao.resetValidation()
    }
  }
}
